import React from 'react';
import { KeyAnalytics } from '../../types';

interface KeyboardHeatmapProps {
  data: KeyAnalytics;
  title?: string;
}

const KEYBOARD_LAYOUT = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm']
];

const KeyboardHeatmap: React.FC<KeyboardHeatmapProps> = ({ data, title = 'Personal Key Hotspots' }) => {
    const maxErrors = Math.max(1, ...Object.values(data));

    const getColor = (char: string) => {
        const count = data[char.toLowerCase()] || 0;
        if (count === 0) return 'bg-gray-200';
        const intensity = Math.min(1, count / maxErrors);
        const r = Math.round(254 + intensity * (185 - 254));
        const g = Math.round(249 + intensity * (28 - 249));
        const b = Math.round(195 + intensity * (28 - 195));
        return `rgb(${r}, ${g}, ${b})`;
    };

    return (
        <div className="w-full p-2 bg-gray-100 rounded-lg">
            <h4 className="text-md font-semibold text-center text-gray-700 mb-2">{title}</h4>
            {KEYBOARD_LAYOUT.map((row, rowIndex) => (
                <div key={rowIndex} className="flex justify-center">
                    {row.map((key) => (
                        <div key={key}
                             className="h-9 flex-1 m-0.5 rounded font-mono font-semibold text-gray-800 flex items-center justify-center text-sm shadow-sm"
                             style={{ backgroundColor: getColor(key) }}
                        >
                            {key}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default KeyboardHeatmap;
